<template>
    <div>
      <div :class="{videoBox: true, videoBoxTwo: isShow}" width="100%" height="100%">
            <video ref='video' id='video' width="100%" height="100%" autoplay loop muted style="object-fit:fill">
                <source :src="videourl" type="video/mp4">
            </video>
        </div>
        <div class="topBox">
          <ul class="top flexBox justifyBetweet nowrap boxsize">
              <li class="slogan">海纳百川·创享未来</li>
              <li class="toptitle">职工三创成果展示</li>
              <li class="time">{{time}}</li>
          </ul>  
        </div>
        <div class="gohome Animation" v-show='goHomeShow' @click="goHome">
            <img :src="homeurl" alt="">
        </div>  
    </div>   
     
</template>
<script>
export default {
  name: 'Head',  
  props:{
    title: String
  },
  data(){
    return {
       homeurl:`${process.env.BASE_URL}` + "image/homego.png",
       myurl: `${process.env.BASE_URL}` + "image/guan.png",
       videourl: `${process.env.BASE_URL}` + "video/154.mp4",
       time: '',
       isFirst:false,
       goHomeShow: false,
       isShow: false,
    }
  },
  created(){
      let date,
      formatStr = 'YYYY-MM-dd HH:mm:ss';

      function updateTime(){
        date = new Date();
        this.time = this.formatDate(date, formatStr);
        requestAnimationFrame(updateTime.bind(this))
      }
      updateTime.call(this)
      this.Event.$on("goHomeShow",(isShow)=>{
        this.goHomeShow = isShow;
        this.isShow = true;
      })
      this.Event.$on('bgtv',(value)=>{
        console.log('-----------------');
        this.videourl = `${process.env.BASE_URL}` + value;
        this.$refs.video.load();
        this.$refs.video.play();
      })
  },

  mounted () {
    
    let vedioElem = document.getElementById('video');
      console.log(vedioElem);
      vedioElem.addEventListener('canplaythrough', ()=>{
        if(!this.isFirst){
          this.Event.$emit('load', false);
          this.isFirst = true;
        }
        return

        
      });
  },
  methods:{
    goHome(){
      this.$router.push('/');
      this.goHomeShow = false;
      this.isShow = false;
    },
    formatDate(date, formatStr) {
        let str = formatStr;
        let Week = ['日', '一', '二', '三', '四', '五', '六'];

        str = str.replace(/yyyy|YYYY/, date.getFullYear());
        str = str.replace(/yy|YY/, date.getYear() % 100 > 9 ? (date.getYear() % 100).toString() : '0' + date.getYear() % 100);
        let month = date.getMonth() + 1;
        str = str.replace(/MM/, month > 9 ? month.toString() : '0' + month);
        str = str.replace(/M/g, month);

        str = str.replace(/w|W/g, Week[date.getDay()]);

        str = str.replace(/dd|DD/, date.getDate() > 9 ? date.getDate().toString() : '0' + date.getDate());
        str = str.replace(/d|D/g, date.getDate());

        str = str.replace(/hh|HH/, date.getHours() > 9 ? date.getHours().toString() : '0' + date.getHours());
        str = str.replace(/h|H/g, date.getHours());
        str = str.replace(/mm/, date.getMinutes() > 9 ? date.getMinutes().toString() : '0' + date.getMinutes());
        str = str.replace(/m/g, date.getMinutes());
        str = str.replace(/ss|SS/, date.getSeconds() > 9 ? date.getSeconds().toString() : '0' + date.getSeconds());
        str = str.replace(/s|S/g, date.getSeconds());

        return str;
    },
  }
}
</script>
<style scoped>

</style>